import { Fragment, useEffect, useState } from "react";
import { ProductStockStatus } from "./productStockStatus";
import { ProductStockStatusContainer } from "../../Layout/Common/productStockStatusContainer";

export const HybridMainTitle = ({ params, subHeading, stockStatus }) => {
  const [familyData, setFamilyData] = useState(null);
  const [subTitle, setSubTitle] = useState(null);
  const [showfamily, setShowfamily] = useState(true);
  const [productStockStatus, setProductStockStatus] = useState(true);

  useEffect(() => {
    if (params) {
      setFamilyData(params ?? null);
      setShowfamily(params.isFamily ?? true);
    }
  }, [params]);

  useEffect(() => {
    if (stockStatus) {
      setProductStockStatus(stockStatus);
    }
  }, [stockStatus]);

  useEffect(() => {
    setSubTitle(subHeading ?? "");
  }, [subHeading]);

  return (
    <Fragment>
      {familyData && (
        <div className={`product-detail-info ${showfamily == true ? "pb-0 border-0 border-0" : ""}`}>
          {familyData.brand && (
            <p className="product-seller">
              Brand: <a href="#">{familyData.brand}</a>
            </p>
          )}
          <h1>{familyData.familyName}</h1>
          {showfamily == false ? (
            <Fragment>
              {subTitle && (
                <Fragment>
                  <small>{subTitle}</small>
                  <br />
                </Fragment>
              )}
            </Fragment>
          ) : (
            <small>{familyData.familyShortDesc}</small>
          )}
        </div>
      )}
    </Fragment>
  );
};
